<template>
  <div class="order-step">
    <div class="two-col-res">
      <div>
        <div class="card">
          <div class="card-selection">
            <div class="list-container list-left list-header">
              <address-list
                :currentAddress="address"
                type="deliver"
                @setAddress="setAddress"
              ></address-list>
            </div>

            <div class="selection-main">
              <div class="title-container">
                <h3>Bezorgadres</h3>
                <button
                  class="white-pill-s"
                  @click="editAddress('edit')"
                  v-if="!custom.addresses.editDelivery && address.id"
                >
                  Bewerken
                </button>

                <button
                  class="white-pill-s"
                  v-if="!custom.addresses.newDelivery"
                  @click="editAddress('new')"
                >
                  Nieuw
                </button>
              </div>
              <div>
                <div class="address">
                  <p
                    class="error-text pointer"
                    v-if="!address.company"
                    @click="editAddress('new')"
                  >
                    Uw bezorgadres is nog niet compleet, klik hier.
                  </p>
                  <p v-else>{{ address.company }}</p>
                  <p
                    v-if="!address.department && custom.department.required"
                    class="error-text pointer"
                    @click="editAddress('edit')"
                  >
                    <span>Vul een </span>
                    <span
                      >{{
                        custom.department.label
                          ? custom.department.label
                          : 'Afdeling'
                      }}
                    </span>
                    <span>in, klik hier.</span>
                  </p>
                  <p v-else-if="address.department">
                    <span
                      >{{
                        custom.department.label
                          ? custom.department.label
                          : 'Afd. '
                      }}
                    </span>
                    <span>{{ address.department }}</span>
                  </p>
                  <p v-if="address.name">T.a.v. {{ address.name }}</p>
                  <p>
                    {{ address.street }} {{ address.number }}
                    {{ address.addition }}
                  </p>
                  <p>{{ address.zipCode }} {{ address.city }}</p>
                  <p class="org-text" v-if="returnText">
                    De originelen worden ook op dit adres geretourneerd.
                  </p>
                </div>
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!hideSub">
        <div class="card card-front sub-card">
          <div class="card-default">
            <div class="top">
              <day-picker
                :dates="dates"
                :active-date="orderDetails.deliveryDate"
                @setDate="setDate"
                class="day-picker"
                type="deliver"
              ></day-picker>
            </div>
            <address-card :address="shop"></address-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DayPicker from '@/components/ui/DayPicker'
import AddressCard from '@/components/AddressCard'
import AddressSelectionList from '@/components/AddressSelectionList'

import EditDeliveryAddress from '@/dialogs/EditDeliveryAddress'

export default {
  props: {
    orderDetails: {},
    shop: {
      default() {
        return {}
      }
    },
    dates: {
      default() {
        return []
      }
    },
    returnText: {},
    hideSub: { default: false }
  },
  data() {
    return {
      cardBack: '',
      addresses: []
    }
  },
  components: {
    DayPicker,
    AddressList: AddressSelectionList,
    AddressCard
  },
  methods: {
    editAddress(type) {
      this.$modal.show(
        EditDeliveryAddress,
        {
          type: type,
          address: { ...this.address },
          callback: (model) => {
            this.setAddress(model)
          }
        },
        { width: 420, height: 'auto' }
      )
    },
    updateOrder(key, val) {
      this.$emit('updateOrder', [key, val])
    },
    setAddress(address) {
      this.updateOrder('deliveryAddress', address)
    },
    setDate(date) {
      date.time = date.times[0].time
      this.updateOrder('deliveryDate', date)
    }
  },
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    address() {
      return this.orderDetails.deliveryAddress
    }
  }
}
</script>

<style lang="scss" scoped>
.list-header {
  padding-top: 15px;
}
.address {
  line-height: 1.5rem;
  min-height: 175px;
}

.times {
  margin-top: 14px;
}

.org-text {
  margin-top: 17px;
}

.top {
  flex-grow: 1;
}
</style>
